import { useState, useRef } from 'react'

export const useAttachments = () => {
  const [attachments, setAttachments] = useState<File[]>([])
  const [showAttachments, setShowAttachments] = useState<boolean>(false)
  const fileInputRef = useRef<HTMLInputElement>(null)

  // Obsługa dodawania załączników
  const handleAttachmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files != null) {
      const newFiles = Array.from(e.target.files)
      setAttachments([...attachments, ...newFiles])
      setShowAttachments(true)
    }
  }

  // Usuwanie załącznika
  const handleRemoveAttachment = (index: number) => {
    const newAttachments = [...attachments]
    newAttachments.splice(index, 1)
    setAttachments(newAttachments)

    if (newAttachments.length === 0) {
      setShowAttachments(false)
    }
  }

  // Resetowanie załączników
  const resetAttachments = () => {
    setAttachments([])
    setShowAttachments(false)
  }

  return {
    attachments,
    setAttachments,
    showAttachments,
    setShowAttachments,
    fileInputRef,
    handleAttachmentChange,
    handleRemoveAttachment,
    resetAttachments
  }
}
